import { SessionCacheContainer } from '__context/SessionCache';
import { Emh5Host } from 'emh5-hybrid';
import 'emrn-design/polyfill/defaultStyle';
import { Logger } from 'emrn-hybrid/Logger';
import { EmNavigationState } from 'emrn-navigation';
import { EMAppProps } from 'emrn-navigation/EMAppPropsContext';
import { EMAppPropsProvider } from 'emrn-navigation/EMAppPropsContext';
import { WebAppProps, createWebApp, WebNavigationActionType } from 'emrn-navigation/web';
import React, { Component, ComponentClass } from 'react';
import ConfigJSON from '../config.json';
import { getRoutes, defaultRouteName } from '../pages/routes';
import '../polyfills/hybrid.web';
import '../polyfills/pxConverter.web';
import { getRoutesConfig } from './shared';

/**
 * 项目根组件
 */
export class App extends Component<EMAppProps> {
  static displayName = 'RNWebApp';
  private readonly contextProps: EMAppProps;
  private readonly EMApp: ComponentClass<WebAppProps>;

  constructor(props: EMAppProps) {
    super(props);
    const { routes, initialRouteName } = getRoutesConfig({
      appProps: props,
      defaultRouteName,
      routes: getRoutes(),
    });
    this.EMApp = createWebApp({
      routes,
      initialRouteName,
      appId: ConfigJSON.appName,
      mode: Emh5Host.isEastmoneyApp ? 'hash' : 'search',
    });
    this.contextProps = { ...props, theme: Emh5Host.appSkinTheme };
  }

  render() {
    const { EMApp, contextProps } = this;
    return (
      <EMAppPropsProvider value={contextProps}>
        <SessionCacheContainer>
          <EMApp disableStateStack={!Emh5Host.isEastmoneyApp} onNavigationStateChange={onNavigationStateChange} />
        </SessionCacheContainer>
      </EMAppPropsProvider>
    );
  }
}

function onNavigationStateChange(prev: EmNavigationState, next: EmNavigationState, type: WebNavigationActionType) {
  const { params = {}, routeName } = next;
  Logger.info({
    tag: 'RNWeb页面导航',
    msg: `${type}: routeName=${routeName}, params=${JSON.stringify(params)}`,
  });
}
